import { render, staticRenderFns } from "./authForm.vue?vue&type=template&id=9b5246e0&"
import script from "./authForm.vue?vue&type=script&lang=js&"
export * from "./authForm.vue?vue&type=script&lang=js&"
import style0 from "./authForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports